import type { Ref, WritableComputedRef } from 'vue'
import { ref, watch } from 'vue'

export type FullscreenWizardStep = number | 'complete'

type FullscreenWizardStepTransitionName =
    | 'step-next'
    | 'step-previous'
    | 'step-last'
type FullscreenWizardStepTransitionMode = 'out-in' | 'default'

export function useFullscreenWizardTransition(
    currentStep:
        | WritableComputedRef<FullscreenWizardStep>
        | Ref<FullscreenWizardStep>
): {
    stepTransitionName: Ref<
        FullscreenWizardStepTransitionName,
        FullscreenWizardStepTransitionName
    >
    stepTransitionMode: Ref<
        FullscreenWizardStepTransitionMode,
        FullscreenWizardStepTransitionMode
    >
} {
    const stepTransitionName =
        ref<FullscreenWizardStepTransitionName>('step-next')

    watch(currentStep, (value, oldValue) => {
        if (value === 'complete') {
            stepTransitionName.value = 'step-last'
        } else if (oldValue !== 'complete' && value > oldValue) {
            stepTransitionName.value = 'step-next'
        } else {
            stepTransitionName.value = 'step-previous'
        }
    })

    const stepTransitionMode =
        ref<FullscreenWizardStepTransitionMode>('default')

    watch(currentStep, (value) => {
        if (value === 'complete') {
            stepTransitionMode.value = 'out-in'
        } else {
            stepTransitionMode.value = 'default'
        }
    })

    return {
        stepTransitionName,
        stepTransitionMode,
    }
}
